// Pure state helpers — return plain objects, no setState calls.

export function getInitialState() {
  const p1Pieces = ["5S", "4S", "3S", "2S", "1S",
    "C", "LC", "M", "CA", "1L", "2L", "S", "F", "SP", "SP",
    "P", "P", "P", "P", "P", "P"];
  const p2Pieces = ["5S", "4S", "3S", "2S", "1S",
    "C", "LC", "M", "CA", "1L", "2L", "S", "F", "SP", "SP",
    "P", "P", "P", "P", "P", "P"];
  return {
    squares: Array(72).fill(null),
    playerPositions: Array(72).fill(null),
    turn: "1",
    selected: null,
    possibleMoves: Array(4).fill(null),
    phase: "player1_setup",
    p1PiecesToPlace: p1Pieces,
    p2PiecesToPlace: p2Pieces,
    pendingBattle: null,
    moveHistory: [],
  };
}

// Returns { squares, playerPositions, moveHistory } for a normal move.
export function applyMove(state, fromIdx, toIdx) {
  const squares = state.squares.slice();
  const playerPositions = state.playerPositions.slice();

  const moveHistoryEntry = {
    turn: state.turn,
    type: "move",
    piece: squares[fromIdx],
    from: fromIdx,
    to: toIdx,
    outcome: null,
  };

  squares[toIdx] = squares[fromIdx];
  playerPositions[toIdx] = playerPositions[fromIdx];
  squares[fromIdx] = null;
  playerPositions[fromIdx] = null;

  return {
    squares,
    playerPositions,
    moveHistory: [...state.moveHistory, moveHistoryEntry],
  };
}

// Returns { squares, playerPositions, moveHistory } after battle resolves.
export function applyBattleOutcome(state, battle) {
  const squares = state.squares.slice();
  const playerPositions = state.playerPositions.slice();
  const { fromIdx, toIdx, attackerPiece, attackerPlayer, outcome } = battle;

  if (outcome === "attacker") {
    squares[toIdx] = attackerPiece;
    playerPositions[toIdx] = attackerPlayer;
    squares[fromIdx] = null;
    playerPositions[fromIdx] = null;
  } else if (outcome === "defender") {
    squares[fromIdx] = null;
    playerPositions[fromIdx] = null;
  } else { // tie
    squares[fromIdx] = null;
    playerPositions[fromIdx] = null;
    squares[toIdx] = null;
    playerPositions[toIdx] = null;
  }

  const moveHistoryEntry = {
    turn: attackerPlayer,
    type: "battle",
    piece: attackerPiece,
    from: fromIdx,
    to: toIdx,
    outcome,
  };

  return {
    squares,
    playerPositions,
    moveHistory: [...state.moveHistory, moveHistoryEntry],
  };
}
